document.addEventListener('DOMContentLoaded', function(){
    const containerSubs = document.querySelector('.js-sbs-container');
    const containerOtp = document.querySelector('.js-otp-container');
    const savePercentage = document.getElementById('save-percentage');

    const discounts = {
        "1-pack": discountOnePackSubs,
        "2-pack": discountTwoPackSubs,
        "3-pack": discountThreePackSubs
    };

    function updateDiscountValue(){
        const selectedOption = document.querySelector('input[name="Pack"]:checked');
        if(selectedOption){
            const packType = selectedOption.value;
            const discountValue = discounts[packType] || 0;
            savePercentage.textContent = discountValue;
        }
    }
    document.querySelectorAll('input[name="Pack"]').forEach(input => {
        input.addEventListener('change',updateDiscountValue);
    });
    updateDiscountValue();

    function toggleDiscounts(isSubsSelected) {
        const subsDiscounts = document.querySelectorAll('.subs-discount');
        const otpDiscounts = document.querySelectorAll('.otp-discount');

        subsDiscounts.forEach(discount => {
            discount.style.display = isSubsSelected ? 'block' : 'none';
        });
        otpDiscounts.forEach(discount =>{
            discount.style.display = isSubsSelected ? 'none' : 'block';
        });
    }

    // Obtener los inputs de sabor y pack seleccionados
    const flavorInputs = document.querySelectorAll('input[name="Flavor"]');
    const packInputs = document.querySelectorAll('input[name="Pack"]');

    // Asignar evento de cambio para las opciones seleccionadas
    flavorInputs.forEach(input => {
        input.addEventListener('change', updatePrice);
    });
    packInputs.forEach(input => {
        input.addEventListener('change', updatePrice);
    });
    function normalizeVariantKey(value) {
        return value
            .replace(/\//g, '-') // Reemplaza '/' con '-'
            .replace(/'/g, '')   // Elimina comillas simples ('')
            .replace(/\s+/g, ''); // Elimina todos los espacios
    }
    // Función para actualizar los precios
    function updatePrice() {
        // Verificar si existen variantes Flavor y Pack seleccionadas
        const selectedFlavorBundleInput = document.querySelector('input[name="Picky Eater Multi Flavor:"]:checked');
        const selectedFlavorInput = document.querySelector('input[name="Flavor"]:checked');
        const selectedPackInput = document.querySelector('input[name="Pack"]:checked');
        const selectedFlavorBundle = selectedFlavorBundleInput ? selectedFlavorBundleInput.value : '';
        const selectedFlavor = selectedFlavorInput ? selectedFlavorInput.value : '';
        const selectedPack = selectedPackInput ? selectedPackInput.value : '';

        // Crear la clave según las variantes disponibles
        let flavorPackKey = '';
        if (selectedFlavor && selectedPack) {
            flavorPackKey = `${normalizeVariantKey(selectedFlavor)}-${normalizeVariantKey(selectedPack)}`;
        } else if (selectedFlavor) {
            flavorPackKey = `${normalizeVariantKey(selectedFlavor)}`;
        } else if (selectedPack) {
            flavorPackKey = `${normalizeVariantKey(selectedPack)}`;
        } else if (selectedFlavorBundle) {
            flavorPackKey = `${normalizeVariantKey(selectedFlavorBundle)}`;
        }else {
            flavorPackKey = "DefaultTitle"
        }
        // Obtener todos los inputs de precios ocultos
        const priceInputs = Array.from(document.querySelectorAll('.js-input-price-otp, .js-input-price-autoship'));

        // Crear un array de precios con ID y valor
        const prices = priceInputs.map(input => ({
            id: input.id, // ID dinámico (otp-bundle-variantName o autoship-variantName)
            value: input.value, // Precio con descuento
            original: input.dataset.variantPrice, // Precio original desde data-attribute
        }));

        // Buscar el precio OTP relacionado con la variante seleccionada
        const selectedPriceOtp = prices.find(price => price.id === `otp-bundle-${flavorPackKey}`);
        const selectedPriceAutoship = prices.find(price => price.id === `autoship-${flavorPackKey}`);

        // Actualizar los precios en el DOM
        const originalPriceOtp = document.querySelector('.js-original-price-otp');
        const priceOtp = document.querySelector('.js-price-otp');
        const originalPriceAutoship = document.querySelector('.js-original-price-auto');
        const priceAutoship = document.querySelector('.js-price-autoship');

        // Actualizar precios OTP
        if (originalPriceOtp && priceOtp && selectedPriceOtp) {
            originalPriceOtp.textContent = selectedPriceOtp.original;
            priceOtp.textContent = selectedPriceOtp.value;
            if (selectedPriceOtp.original === selectedPriceOtp.value) {
                originalPriceOtp.style.display = "none"
            } else {
                originalPriceOtp.style.display = ""
            }
        }

        // Actualizar precios Autoship
        if (originalPriceAutoship && priceAutoship && selectedPriceAutoship) {
            originalPriceAutoship.textContent = selectedPriceAutoship.original;
            priceAutoship.textContent = selectedPriceAutoship.value;
            if (selectedPriceAutoship.original === selectedPriceAutoship.value) {
                originalPriceAutoship.style.display = "none"
            } else {
                originalPriceAutoship.style.display = ""
            }
        }
    }
    // Actualizar precios al cargar la página
    updatePrice();
    containerSubs.addEventListener('click', function () {
        toggleDiscounts(true);
    });
    containerOtp.addEventListener('click', function () {
        toggleDiscounts(false);
    });
});